<app-shell icon="close" [breadCrumbs]="[data.title]" (close)="close()">
  <app-cards-vertical #templatesSelection [cardsList]="data.cards$ | async" (drilldown)="selectedItem($event)">
  </app-cards-vertical>
</app-shell>
